// Header language switcher navigation + homepage-only browser language auto-detect.
// CustomSelect (custom-select.js) fires a click on the chosen option for both
// mouse and keyboard selection, so a single click listener covers both paths.

const COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 365; // 1 year

function getCookie(name) {
	const match = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '=([^;]*)'));
	return match ? decodeURIComponent(match[1]) : '';
}

function setLangPrefCookie(name, value) {
	const secure = window.location.protocol === 'https:' ? '; Secure' : '';
	document.cookie = `${name}=${encodeURIComponent(value)}; path=/; max-age=${COOKIE_MAX_AGE_SECONDS}; SameSite=Lax${secure}`;
}

function preferredBrowserLang(supportedCodes) {
	const candidates = [
		...(navigator.languages || []),
		navigator.language || '',
		navigator.userLanguage || '',
	]
		.filter(Boolean)
		.map((lang) => String(lang).toLowerCase());

	for (const candidate of candidates) {
		const base = candidate.split('-')[0];
		if (supportedCodes.includes(base)) {
			return base;
		}
	}
	return '';
}

function runHomepageAutodetect() {
	const config = window.dequeWeglotAutodetect;
	if (!config || !config.cookieName || !config.targets) {
		return;
	}

	const cookieName = config.cookieName;
	if (getCookie(cookieName)) {
		return;
	}

	const supported = Object.keys(config.targets);
	const match = preferredBrowserLang(supported);
	const targetUrl = match ? config.targets[match] : '';
	if (!match || !targetUrl) {
		return;
	}

	setLangPrefCookie(cookieName, match);
	if (targetUrl !== window.location.href) {
		window.location.replace(targetUrl);
	}
}

document.addEventListener('DOMContentLoaded', () => {
	const config = window.dequeWeglotAutodetect;
	const cookieName = (config && config.cookieName) || 'deque_lang_pref';

	document.querySelectorAll('.language-switcher .custom-select__option').forEach((option) => {
		option.addEventListener('click', () => {
			const url = option.dataset.value;
			if (!url || url === window.location.href) {
				return;
			}
			const code = option.getAttribute('lang') || 'en';
			setLangPrefCookie(cookieName, code);
			window.location.assign(url);
		});
	});

	runHomepageAutodetect();
});
